module.exports = __webpack_public_path__ + "static/media/food_anchorage_2.567059c5.svg";